import React, { createContext, useContext } from 'react'
import { GeckoComponent, GeckoInspection, GeckoReport, GeckoUnit } from 'types'

interface ImagesContextType {
  assetThumbnailURLs: readonly string[]
  assetThumbnails: readonly GeckoReport[]
  imageVisibility: boolean[]
  setImageVisibility: React.Dispatch<React.SetStateAction<boolean[]>>
  forceRefresh: () => Promise<void>
  components: readonly GeckoComponent[]
  inspections: readonly GeckoInspection[]
  canUploadFiles: boolean | undefined
  unit?: GeckoUnit
}

const ImagesContext = createContext<ImagesContextType | undefined>(undefined)

export const useImagesContext = () => {
  const context = useContext(ImagesContext)
  if (!context) {
    throw new Error('useImagesContext must be used within an ImagesProvider')
  }
  return context
}

export const ImagesProvider: React.FC<
  ImagesContextType & { children: React.ReactNode }
> = ({ children, ...values }) => {
  return (
    <ImagesContext.Provider value={values}>{children}</ImagesContext.Provider>
  )
}
